import { Form, Input } from 'antd';
import React from 'react';
import { sanitizeInput } from '../../utilities/commonFunctions';
import { ReactComponent as PasswordVisibleSvg } from '../../assets/icons/password-visible.svg';
import { ReactComponent as PasswordHiddenSvg } from '../../assets/icons/password-hide.svg';
import Icon from '@ant-design/icons';
import PropTypes from 'prop-types';

const CustomRegistrationFormInput = ({
  label,
  placeholder,
  name,
  rules,
  validateStatus,
  help,
  onChange,
  disabled = false,
  readOnly = false,
  width = '100%',
  isPassword = false,
  shouldUppercase = false,
  prefix = null,
  marginBottom = '24px',
}) => {
  const formatInputValue = value => {
    const sanitizedValue = sanitizeInput(value);

    return shouldUppercase ? sanitizedValue.toUpperCase() : sanitizedValue;
  };

  const handleChange = e => {
    const formattedValue = formatInputValue(e.target.value);
    onChange?.({ ...e, target: { ...e.target, value: formattedValue } });
  };

  return (
    <Form.Item
      name={name}
      rules={rules}
      label={label}
      style={{ width, marginBottom }}
      validateStatus={validateStatus}
      help={help}
      getValueFromEvent={e => formatInputValue(e?.target?.value ?? '')}
    >
      {isPassword ? (
        <Input.Password
          className="input-search"
          autoComplete="off"
          placeholder={placeholder}
          readOnly={readOnly}
          onChange={handleChange}
          iconRender={visible =>
            visible ? (
              <Icon component={PasswordVisibleSvg} />
            ) : (
              <Icon component={PasswordHiddenSvg} />
            )
          }
        />
      ) : (
        <Input
          className="input-search"
          autoComplete="off"
          placeholder={placeholder}
          readOnly={readOnly}
          onChange={handleChange}
          disabled={disabled}
          prefix={prefix}
        />
      )}
    </Form.Item>
  );
};

CustomRegistrationFormInput.propTypes = {
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  placeholder: PropTypes.string,
  prefix: PropTypes.string,
  marginBottom: PropTypes.string,
  name: PropTypes.oneOfType([PropTypes.string, PropTypes.array]).isRequired,
  rules: PropTypes.arrayOf(PropTypes.object),
  validateStatus: PropTypes.string,
  help: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  readOnly: PropTypes.bool,
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  isPassword: PropTypes.bool,
  shouldUppercase: PropTypes.bool,
};

export default React.memo(CustomRegistrationFormInput);
